<template>
  <svg class="donut inline" viewBox="0 0 100 100">
      <circle class="bg" cx="50" cy="50" r="40" stroke-width="20" :stroke="getBgColor"/>
      <circle class="fill" cx="50" cy="50" r="40" stroke-width="20" :stroke="getColor" stroke-dasharray="251.2" :stroke-dashoffset="getValue()"/>
  </svg>
</template>


<script>
export default {
  props: ['pct','color','bgcolor'],
  computed: {
    getBgColor(){
      if( this._props.bgcolor ) return this._props.bgcolor
      return 'rgba(0,0,0,.1)'
    },
    getColor(){
      if( this._props.color ) return this._props.color
      return 'rgba(0,0,0,1)'
    },
  },
  methods: {
    getValue(){
      return (100 - this.pct) * 2.5122
    },
  },
}
</script>

<style lang="scss">
	@import '../styling/global_vars';

  svg.donut {
		transform: rotate(-90deg);
    height: 100px;
    width: 100px;
    //background-color: pink;
	}

	svg.donut .bg {
		//stroke: rgba(black,0.2);
    fill: transparent;
	}

	svg.donut .fill {
		//stroke: black;
    fill: transparent;
		transition: all 1500ms $easeOutCubic;
	}

	svg.donut.inline {
		display: inline;
		width: 3em;
		height: 3em;
		//margin-bottom: -0.2em;
	}

</style>



// WEBPACK FOOTER //
// Minidonut.vue?6720d6f8